import { render } from "./Ecosystem.vue?vue&type=template&id=0b664f5d&scoped=true"
import script from "./Ecosystem.vue?vue&type=script&lang=js"
export * from "./Ecosystem.vue?vue&type=script&lang=js"

import "./Ecosystem.vue?vue&type=style&index=0&id=0b664f5d&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b664f5d"]])

export default __exports__